<template>
  <!-- Page Content -->
  <div class="whole-page-long" id="whole-page-div">
    <div
      class="left-sidebar-front-div"
      v-if="Analytics['userSelections']['visibleLeft']"
      @click="
        Analytics['userSelections']['visibleLeft'] = !Analytics[
          'userSelections'
        ]['visibleLeft']
      "
    ></div>

    <!--contents-->
    <div class="h-100 d-flex flex-column">
      <div class="row f-row h-100">
        <LeftSidebarAnalytics
          :selectedAnalysis="Analytics['userSelections']['selectedAnalysis']"
          :selectedAnalysisParent="
            Analytics['userSelections']['selectedAnalysisParent']
          "
          :visibleLeft="Analytics['userSelections']['visibleLeft']"
          :selectedChildName="computedSelectedChildName"
          @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
          @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
          @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
          @eventOnSidebarItemsChange="onSidebarItemsChange"
        />
        <div class="largeBox">
          <div class="row f-row h-100 justify-content-center">
            <div class="col col-12 h-100 text-center">
              <div
                v-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'portfolio'
                "
                class="justify-content-center vert-align no_nav_height"
                style="top: 60px!important; width: 100%!important; "
              >
                <div class="col col-12 text-center inh no_nav_height">
                  <div class="row f-row mb-2">
                    <div
                      class="markets-chart-title col col-12"
                      style="text-align: center!important;"
                    >
                      PORTFOLIO COMPOSITION
                    </div>
                  </div>
                  Coming soon...
                </div>
              </div>
              <MonthlyValuation
                v-else-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'valuation'
                "
                :Analytics="Analytics"
                :companyParametersReady="companyParametersReady"
                :dataFilters="Analytics['valuation']['dataFilters']"
                :processData="processData"
                @eventOnUserFilter="onUserFilterValuation"
                @eventOnUserFinalDate="onUserFinalDate"
                @eventOnUserFinalSpot="onUserFinalSpot"
                @eventOnUserInitialDate="onUserInitialDate"
                @eventOnUserInitialSpot="onUserInitialSpot"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserAccountingValuate="onUserAccountingValuate"
                @eventOnUserInitialSpotChange="onUserInitialSpotChange"
                @eventOnUserInitialSpotRefresh="onUserInitialSpotRefresh"
                @eventOnUserFinalSpotChange="onUserFinalSpotChange"
                @eventOnUserFinalSpotRefresh="onUserFinalSpotRefresh"
              />
              <CommodityContractManagement
                v-else-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'contractManagement'
                "
                :Analytics="Analytics"
                :companyParametersReady="companyParametersReady"
                :processData="processData"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnFilteredData="onFilteredData"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserFetchExpand="onUserFetchExpand"
              />
              <VisualizationChartsTable
                v-else-if="
                  ['scenario'].includes(
                    Analytics['userSelections']['selectedAnalysis'],
                  )
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :eventElement="eventElement"
                :processData="processData"
                :screenWidth="screenWidth"
                @eventOnClientExpandSidebar="onClientExpandSidebar"
                @eventOnFilteredData="onFilteredData"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserNormalizeQty="onUserNormalizeQty"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserShow="onUserShow"
                @eventOnUserShowDetails="onUserShowDetails"
                @eventOnUserSpotChange="onUserSpotChange"
                @eventOnUserYear="onUserYear"
                @eventOnUserZoom="onUserZoom"
                @resizeCharts="resizeCharts"
              />
              <CommodityScenarios
                v-else-if="
                  [
                    'scenarios',
                    'strategies',
                    'derivatives',
                    'providers',
                    'clients',
                    'counterparty',
                  ].includes(Analytics['userSelections']['selectedAnalysis']) &&
                    Analytics['userSelections'][
                      'selectedAnalysisParent'
                    ].includes('scenario')
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :processData="processData"
                :screenWidth="screenWidth"
                :eventElement="eventElement"
                @resizeCharts="resizeCharts"
                @eventOnClientExpandSidebar="onClientExpandSidebar"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnFilteredData="onFilteredData"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserShow="onUserShow"
                @eventOnUserSpotChange="onUserSpotChange"
                @eventOnUserShowDetails="onUserShowDetails"
                @eventOnUserZoom="onUserZoom"
                @eventOnUserNormalizeQty="onUserNormalizeQty"
                @eventOnUserYear="onUserYear"
              />
              <div
                v-else-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'originDestiny'
                "
                class="justify-content-center vert-align no_nav_height"
                style="top: 60px!important; width: 100%!important; "
              >
                <div class="col col-12 text-center inh no_nav_height">
                  <div class="row f-row mb-2">
                    <div
                      class="markets-chart-title col col-12"
                      style="text-align: center!important;"
                    >
                      ORIGIN <i class="fa fa-arrow-right"></i> DESTINY
                    </div>
                  </div>
                  Coming soon...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommodityScenarios from "@/components/analytics/CommodityScenarios";
import CommodityContractManagement from "@/components/analytics/ManagementConsolidations.vue";
import LeftSidebarAnalytics from "@/components/analytics/LeftSidebarAnalytics";
import MonthlyValuation from "@/components/analytics/MonthlyValuation";
import VisualizationChartsTable from "@/components/analytics/VisualizationChartsTable.vue";
import {
  AnalyticsCurrency,
  managementFields,
} from "@/_core/data/Analytics/AnalyticsCurrency";
import { AnalyticsManager } from "@/_core/data/Analytics/AnalyticsManager";
import { getCurrencySettle } from "@/_core/data/api_calls/getCurrencySettle";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { initAnalyticsPreferences } from "../../_core/data/Analytics/AnalyticsGeneral";
import { selectAll } from "d3";

export default {
  name: "Currency",
  components: {
    CommodityScenarios,
    LeftSidebarAnalytics,
    MonthlyValuation,
    CommodityContractManagement,
    VisualizationChartsTable,
  },
  props: {
    analyticsPreferences: { required: true, default: () => {} },
    colorTheme: { required: true, type: Boolean, default: true },
    companies: {
      required: true,
      default: () => [{ id: 0, company_name: "N.A." }],
    },
    companyParametersReady: { required: true, type: Boolean, default: false },
    countrySpecs: { required: true },
    currencySpecs: { required: true },
    optionTypes: { required: true, default: () => [] },
    processData: { required: true },
  },
  data() {
    return {
      Analytics: AnalyticsManager.defaultAnalytics(this.filterCurr),
      eventElement: {},
      filterCurr: {
        currency: "createInConstraint",
        notional: "createAndConstraint",
        pk_i_idcurrency: "createInConstraint",
      },
      hasBootstrapped: false,
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 11),
      ),
      initManagementDate: new Date(new Date().getFullYear() - 1, 0, 1),
      isApplyingRoute: false,
      isCents: 1,
      isUpdatedRoute: false,
      itemsLeftSidebar: [],
      lCall: require("@/assets/images/lCall.svg"),
      lCallOff: require("@/assets/images/derivUpOff.svg"),
      lCallOn: require("@/assets/images/lCall.svg"),
      lFwd: require("@/assets/images/lFwd.svg"),
      lFwdOff: require("@/assets/images/fwdUpOff.svg"),
      lFwdOn: require("@/assets/images/lFwd.svg"),
      lPut: require("@/assets/images/lPut.svg"),
      lPutOff: require("@/assets/images/derivUpOff.svg"),
      lPutOn: require("@/assets/images/lPut.svg"),
      pendingRoute: null,
      sCall: require("@/assets/images/sCall.svg"),
      sCallOff: require("@/assets/images/derivDownOff.svg"),
      sCallOn: require("@/assets/images/sCall.svg"),
      screenWidth: 0,
      sFwd: require("@/assets/images/sFwd.svg"),
      sFwdOff: require("@/assets/images/fwdDownOff.svg"),
      sFwdOn: require("@/assets/images/sFwd.svg"),
      spot: null,
      sPut: require("@/assets/images/sPut.svg"),
      sPutOff: require("@/assets/images/derivDownOff.svg"),
      sPutOn: require("@/assets/images/sPut.svg"),
      today: new Date(),
    };
  },
  created() {
    document.title = "Analytics | Fx";
    this.pendingRoute = this.$route;

    const storePrefs = this.$store.getters["user_preferences/analyticsChoices"];
    const { analytics_preferences, prefsChanged } = initAnalyticsPreferences(
      storePrefs,
      "currency",
    );

    this.analyticsPreferences = analytics_preferences;

    if (prefsChanged) {
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        analytics_preferences,
      );
      this.saveUserPrefs();
    }
  },
  mounted() {
    this.updateScreenWidth();
    this.bootstrapFromRoute();
  },
  computed: {
    analyticsReady() {
      return (
        this.companyParametersReady === true &&
        this.Analytics &&
        typeof this.Analytics.updateSelectedCompanies === "function"
      );
    },
    loadingExpoHedges() {
      const { expo, hedges } = this.Analytics["loading"];
      return expo || hedges;
    },
    computedSelectedChildName() {
      const selectedAnalysisParent = this.Analytics.userSelections
        .selectedAnalysisParent;
      const selectedAnalysis = this.Analytics.userSelections.selectedAnalysis;

      if (selectedAnalysisParent === "contractManagement") {
        return {
          selectedAnalysis: this.Analytics.userSelections.selectedTable,
          selectedAnalysisParent: selectedAnalysisParent,
        };
      } else if (selectedAnalysisParent === "scenario") {
        return { selectedAnalysis, selectedAnalysisParent: "scenarios" };
      } else if (selectedAnalysisParent && selectedAnalysis) {
        return { selectedAnalysis, selectedAnalysisParent };
      }

      return null;
    },
  },
  watch: {
    companyParametersReady(val) {
      if (val === true) this.bootstrapFromRoute();
    },
    loadingExpoHedges(val) {
      if (val === false) {
        const { hedges } = this.Analytics["rawData"];
        if (hedges.length > 0) {
          this.getSpotFromHedges();
        } else {
          Object.assign(this.Analytics["loading"], {
            topographyCalcs: false,
            strategies: false,
            derivatives: false,
          });
        }
      }
    },
    // selectionStr(val) {
    //   if (this.isApplyingRoute) return;

    //   Object.assign(this.Analytics["userSelections"], {
    //     selectionStr: val,
    //   });
    // },
    // "Analytics.userSelections.selectionStr"() {
    //   if (this.isApplyingRoute) return;
    //   this.updateRoute();
    // },
    optionTypes(val) {
      Object.assign(this.Analytics, {
        optionTypes: val,
      });
    },
    // Analytics: {
    //   handler() {
    //     if (this.isApplyingRoute) return;

    //     this.selectionStr();
    //   },
    //   deep: true,
    // },
    $route: {
      handler(newRoute) {
        if (this.isUpdatedRoute) {
          this.isUpdatedRoute = false;
          return;
        }

        if (this.isApplyingRoute) return;
        if (!this.analyticsReady) return;
        if (this.loadingExpoHedges !== false) return;

        this.validateAndApplyRouteParams(newRoute);
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    saveUserPrefs() {
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analyticsPreferences,
      );
      saveUserPreferences(this);
    },
    bootstrapFromRoute() {
      if (this.hasBootstrapped) return;
      if (!this.companyParametersReady) return;

      this.hasBootstrapped = true;
      this.isApplyingRoute = true;

      this.initiate();

      this.$nextTick(() => {
        const routeToApply = this.pendingRoute || this.$route;
        this.validateAndApplyRouteParams(routeToApply);

        this.isApplyingRoute = false;

        if (this.hasValidFilters()) {
          this.onUserFetchData();
        }
      });
    },
    validateAndApplyRouteParams(route) {
      const { query, params } = route;

      if (params.productType === "currency") {
        if (route.name === "analytics-valuation") {
          this.Analytics.userSelections.selectedAnalysis = "valuation";
          this.Analytics.userSelections.selectedAnalysisParent = "valuation";
        } else if (route.name.includes("analytics-management")) {
          this.Analytics.userSelections.selectedAnalysisParent =
            "contractManagement";
          this.Analytics.userSelections.selectedAnalysis = "contractManagement";
          this.Analytics.userSelections.selectedTable = route.name
            .replace("analytics-management-", "")
            .toLowerCase();
        } else if (route.name.includes("analytics-scenarios")) {
          this.Analytics.userSelections.selectedAnalysisParent = "scenario";
          this.applyScenarioRoute(route.name);

          this.applyScenarioFilters(query);
        } else {
          // Unrecognized route, update route
          this.updateRoute();
        }
      } else {
        // If the user did not write a route or it's not a valid route
        this.isApplyingRoute = false;
        this.updateRoute();
      }
    },
    applyScenarioFilters(query) {
      if (!query.companies || !query.portfolios || !query.currencies) {
        this.updateRoute();
        return;
      }

      if (query.companies) {
        const companyNames = query.companies.split(",");
        const validCompanies = this.companies.filter((c) =>
          companyNames.includes(c.company_name),
        );

        if (validCompanies.length > 0) {
          const portfolios = this.filterPortfoliosByNames(
            validCompanies,
            query.portfolios,
          );
          Object.assign(this.Analytics.userSelections, {
            portfolios: this.Analytics.getPortfolios(validCompanies),
          });
          const assets = this.filterAssetsByNames(portfolios, query.currencies);

          this.onUserCompany(validCompanies, portfolios, assets);
        } else {
          console.warn("No se encontraron compañías válidas:", companyNames);
          return;
        }
      }

      if (this.hasValidFilters()) {
        this.onUserFetchData();
      }
    },
    filterPortfoliosByNames(companies, portfolioQuery) {
      const portfolios = this.Analytics.getPortfolios(companies);
      const filterPortfolios = portfolios.filter((p) =>
        portfolioQuery.split(",").includes(p.name),
      );

      return filterPortfolios || [];
    },
    filterAssetsByNames(portfolios, assetQuery) {
      const assetPK = this.Analytics.getAssets(portfolios, true);
      const listAssets = [];

      assetPK.forEach((pk) => {
        listAssets.push(
          this.Analytics.companyParameters.endProducts.filter(
            (d) =>
              d.pk_id_end_product === pk &&
              assetQuery.split(",").includes(d.product_name),
          )[0],
        );
      });

      return listAssets.filter((a) => a != null);
    },
    applyScenarioRoute(routeName) {
      const routeMap = {
        "analytics-scenarios-portfolio": "portfolio",
        "analytics-scenarios-strategies": "strategies",
        "analytics-scenarios-derivatives": "derivatives",
        "analytics-scenarios-providers": "providers",
        "analytics-scenarios-clients": "clients",
        "analytics-scenarios-counterparty": "counterparty",
      };

      const analysis = routeMap[routeName];
      if (analysis) {
        if (routeMap[routeName] === "portfolio") {
          this.Analytics.userSelections.selectedAnalysis = "scenario";
        } else {
          this.Analytics.userSelections.selectedAnalysis = analysis;
        }
      }
    },
    hasValidFilters() {
      const {
        selectedCompanies,
        selectedPortfolios,
        selectedAsset,
      } = this.Analytics.userSelections;

      return (
        selectedCompanies?.length > 0 &&
        selectedPortfolios?.length > 0 &&
        selectedAsset?.length > 0
      );
    },
    getCommonQueryFilters() {
      const selections = this.Analytics["userSelections"];

      const selectedCompanies = selections["selectedCompanies"] || [];
      const selectedPortfolios = selections["selectedPortfolios"] || [];
      const selectedUnderlying = selections["selectedAsset"] || [];

      // Extraer y filtrar IDs válidos
      const companies = selectedCompanies
        .filter((c) => c && c.pk_idcompany != null)
        .map((c) => c.company_name);

      const portfolios = selectedPortfolios
        .filter((p) => p && p.pk != null)
        .map((p) => p.name);

      const currencies = selectedUnderlying
        .filter((u) => u && u.pk_i_idcurrency != null)
        .map((u) => u.currency_name);

      const filters = {};
      filters.companies = companies.join(",");
      filters.portfolios = portfolios.join(",");
      filters.currencies = currencies.join(",");

      return filters;
    },
    validateSelectedAnalysisPreferences() {
      return (
        this.analyticsPreferences.selectedAnalysis &&
        this.analyticsPreferences.selectedAnalysisParent
      );
    },
    updateAnalysisByPreferences() {
      if (this.validateSelectedAnalysisPreferences()) {
        this.Analytics.userSelections.selectedAnalysis = this.analyticsPreferences.selectedAnalysis;
        this.Analytics.userSelections.selectedAnalysisParent = this.analyticsPreferences.selectedAnalysisParent;
        this.Analytics.userSelections.selectedTable = this.analyticsPreferences.selectedTable;
      }
    },
    updateRoute() {
      if (this.isApplyingRoute) return;

      this.isUpdatedRoute = true;

      let routeName = null;
      const selectedAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];
      const selectedAnalysisParent = this.Analytics["userSelections"][
        "selectedAnalysisParent"
      ];

      if (selectedAnalysis === "valuation") {
        routeName = "analytics-valuation";
      } else if (selectedAnalysisParent === "contractManagement") {
        routeName = this.selectedRouteNameContractManagement();
      } else if (selectedAnalysisParent.includes("scenario")) {
        routeName = this.selectedRouteNameAnalysisScenarios();
      }

      if (!routeName) {
        console.warn("No se pudo determinar el nombre de la ruta");
        return;
      }

      const params = {
        productType: "currency",
      };
      const query = {};

      if (routeName === "analytics-valuation") {
        const commonFilters = this.getCommonQueryFilters();

        if (!commonFilters) {
          console.warn("No se pudieron obtener filtros válidos para valuation");
          return;
        }

        Object.assign(query, commonFilters);
      } else if (selectedAnalysisParent === "contractManagement") {
        const commonFilters = this.getCommonQueryFilters();

        if (!commonFilters) {
          console.warn(
            "No se pudieron obtener filtros válidos para contract management",
          );
        } else {
          Object.assign(query, commonFilters);
        }
      } else if (selectedAnalysisParent.includes("scenario")) {
        const commonFilters = this.getCommonQueryFilters();
        if (!commonFilters) {
          console.warn("No se pudieron obtener filtros válidos para scenarios");
        } else {
          Object.assign(query, commonFilters);
        }
      }

      const routeConfig = {
        name: routeName,
        params,
        query,
      };

      if (
        this.$route.name !== routeConfig.name ||
        JSON.stringify(this.$route.params) !==
          JSON.stringify(routeConfig.params) ||
        JSON.stringify(this.$route.query) !== JSON.stringify(routeConfig.query)
      ) {
        this.$router.push(routeConfig).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Error al actualizar la ruta:", err);
          }
        });
      }

      this.updateLeftSideBar(this.$route.name);
      this.syncPreferencesFromAnalytics();
      this.saveUserPrefs();
    },
    selectedRouteNameContractManagement() {
      switch (this.Analytics["userSelections"]["selectedTable"]) {
        case "strategies":
          return "analytics-management-strategies";
        case "contracts":
          return "analytics-management-contracts";
        case "date_2":
          return "analytics-management-date_2";
        case "clients":
          return "analytics-management-clients";
        case "suppliers":
          return "analytics-management-suppliers";
        default:
          return "analytics-management-strategies";
      }
    },
    selectedRouteNameAnalysisScenarios() {
      switch (this.Analytics["userSelections"]["selectedAnalysis"]) {
        case "scenario":
        case "scenarios":
          return "analytics-scenarios-portfolio";
        case "strategies":
          return "analytics-scenarios-strategies";
        case "derivatives":
          return "analytics-scenarios-derivatives";
        case "providers":
          return "analytics-scenarios-providers";
        case "clients":
          return "analytics-scenarios-clients";
        case "counterparty":
          return "analytics-scenarios-counterparty";
        default:
          return "analytics-scenarios-portfolio";
      }
    },
    updateLeftSideBar(name) {
      if (this.itemsLeftSidebar.length > 0) {
        this.itemsLeftSidebar.forEach((item) => {
          if (item.routeName === name) {
            Object.assign(this.userSelections, {
              selectedAnalysis: item.nameEvent,
            });
          }
        });
      }
    },
    onSidebarItemsChange(items) {
      Object.assign(this, {
        itemsLeftSidebar: items,
      });
    },
    getSpotFromHedges() {
      Object.assign(this.Analytics["loading"], {
        spot: true,
      });
      let spot = null;
      let hLen = this.Analytics["rawData"]["hedges"].length;
      if (hLen > 0) {
        spot =
          this.Analytics["rawData"]["hedges"].find((obj) => obj.spot != null)
            ?.spot ?? null;
        Object.assign(this.Analytics["rawData"], {
          spot: spot,
        });
      }

      if (spot == null) {
        let _this = this;
        let pk = this.Analytics["userSelections"]["selectedAsset"][0][
          "pk_i_idcurrency"
        ];
        getSpotData(
          this,
          "spot",
          "updatedAt",
          "showLoadingValuating",
          "currency",
          null,
          false,
          pk,
        )
          .then((data) => {
            Object.assign(_this.Analytics["rawData"], {
              spot: +data[0]["close"],
            });
            Object.assign(_this.Analytics["loading"], {
              spot: false,
            });
          })
          .catch(function(error) {
            Object.assign(_this.Analytics["loading"], {
              spot: false,
            });
            console.error(error);
          });
      } else {
        Object.assign(this.Analytics["loading"], {
          spot: false,
        });
      }
    },
    initiate() {
      this.Analytics = AnalyticsManager.defaultAnalytics(this.filterComm);
      this.Analytics = new AnalyticsCurrency({
        analyticsPreferences: this.analyticsPreferences,
        assetType: "currency",
        companies: this.companies,
        companyParameters: JSON.parse(
          JSON.stringify(this.$store.state.companyParameters),
        ),
        images: {
          lCall: this.lCall,
          lCallOff: this.lCallOff,
          lCallOn: this.lCallOn,
          lFwd: this.lFwd,
          lFwdOff: this.lFwdOff,
          lFwdOn: this.lFwdOn,
          lPut: this.lPut,
          lPutOff: this.lPutOff,
          lPutOn: this.lPutOn,
          sCall: this.sCall,
          sCallOff: this.sCallOff,
          sCallOn: this.sCallOn,
          sFwd: this.sFwd,
          sFwdOff: this.sFwdOff,
          sFwdOn: this.sFwdOn,
          sPut: this.sPut,
          sPutOff: this.sPutOff,
          sPutOn: this.sPutOn,
        },
        processData: this.processData,
        underlyingSpecs: this.currencySpecs,
        customFilters: this.filterCurr,
      });
      Object.assign(this.Analytics, {
        managementFields: managementFields,
      });

      const storePrefs =
        this.$store.getters["user_preferences/analyticsChoices"] ||
        this.$store.state.user_preferences?.all?.items?.analytics_choices;

      let saveUserPref = this.Analytics.initStoreCompPortAsset(storePrefs);

      if (saveUserPref) {
        this.updateAnalysisByPreferences();
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }

      if (this.optionTypes.length > 0) {
        Object.assign(this.Analytics, {
          optionTypes: this.optionTypes,
        });
      }

      this.selectionStr();
    },
    syncPreferencesFromAnalytics() {
      const {
        selectedCompanies,
        selectedPortfolios,
        selectedAsset,
        selectedUnderlying,
        selectedAnalysis,
        selectedAnalysisParent,
        selectedTable,
      } = this.Analytics.userSelections;

      Object.assign(this.analyticsPreferences, {
        selected_company: selectedCompanies,
        selected_portfolio: selectedPortfolios,
        selected_commodities: selectedAsset,
        selectedUnderlying: selectedUnderlying,
        selectedAnalysis: selectedAnalysis,
        selectedAnalysisParent: selectedAnalysisParent,
        selectedTable: selectedTable,
      });
    },
    selectionStr() {
      if (this.isApplyingRoute) return;

      const str = this.Analytics.stringTitle();
      Object.assign(this.Analytics["userSelections"], {
        selectionStr: str,
      });
    },
    // === scenarios
    onClientExpandSidebar(bool) {
      let rBool = this.Analytics["rawData"]["render"];
      Object.assign(this.Analytics["userSelections"], { expandSidebar: bool });
      for (let i = 0; i < 40; i++) {
        setTimeout(() => {
          Object.assign(this.Analytics["rawData"], {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }
    },
    onUserCompany(newValue, portfolios = null, assets = null) {
      Object.assign(this.Analytics["valuation"], { valuated: false });
      let saveUserPref = this.Analytics.updateSelectedCompanies(
        newValue,
        portfolios,
        assets,
      );

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },
    onUserFilterValuation(fltr) {
      Object.assign(this.Analytics["valuation"], {
        dataFilters: fltr,
      });
    },
    onUserFinalDate(finalDate) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        finalDate: finalDate,
        toBeFetched: true,
      });
    },
    onUserFinalSpot(finalSpot) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        finalSpot: finalSpot,
        toBeFetched: true,
      });
    },
    onUserInitialDate(inDate) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        initialDate: inDate,
        toBeFetched: true,
      });
    },
    onUserInitialSpot(initialSpot) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        initialSpot: initialSpot,
        toBeFetched: true,
      });
    },
    onUserFetchData() {
      this.Analytics.getManagementData(
        this,
        this.initCurrencyDate,
        this.Analytics["userSelections"]["selectedCompanies"],
        this.Analytics["userSelections"]["assetsNums"],
        this.Analytics["userSelections"]["selectedPortfolios"],
      );
      this.selectionStr();
    },
    onFilteredData(data) {
      Object.assign(this.Analytics["rawData"], {
        filteredData: data,
      });
      this.Analytics.nestAndZoom(data);
    },
    onUserFilter(fltr) {
      Object.assign(this.Analytics["rawData"], {
        dataFilters: fltr,
      });
    },
    onUserFetchExpand() {
      Object.assign(this.Analytics["rawData"], {
        toBeFetchedHidden: !this.Analytics["rawData"]["toBeFetchedHidden"],
      });
    },
    onUserPortfolio(newValue) {
      Object.assign(this.Analytics["valuation"], { valuated: false });
      Object.assign(this.Analytics["userSelections"], {
        selectedPortfolios: newValue,
      });
      let saveUserPref = this.Analytics.updateSelectedPortf({ initial: false });

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },
    // === contract management ===
    onUserAsset(assetId) {
      if (typeof assetId === "string") {
        assetId = this.currencySpecs.filter((d) => d.currency_name === assetId);
      }
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        toBeFetched: true,
      });
      Object.assign(this.Analytics["userSelections"], {
        selectedAsset: assetId,
        assetsNums: this.Analytics["userSelections"]["selectedAsset"].map(
          (und) => und.pk_i_idcurrency,
        ),
      });

      const saveUserPref = this.Analytics.updateSelectedAsset(null, false);

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },
    onUserShow(str) {
      let bool = !this.Analytics["userSelections"][str];
      if (str === "showAll" && bool) {
        Object.assign(this.Analytics["userSelections"], {
          showAve: bool,
        });
      }
      // if (
      //   str === "showAll" &&
      //   !bool &&
      //   this.Analytics["userSelections"].showAve
      // ) {
      //   Object.assign(this.Analytics["userSelections"], {
      //     showAve: bool,
      //   });
      // }
      // if (
      //   str === "showAve" &&
      //   !bool &&
      //   !this.Analytics["userSelections"].showAll
      // ) {
      //   Object.assign(this.Analytics["userSelections"], {
      //     showAll: bool,
      //   });
      // }

      if (
        str === "showAve" &&
        bool &&
        !this.Analytics["userSelections"].showAll
      ) {
        Object.assign(this.Analytics["userSelections"], {
          showAll: bool,
        });
      }

      if (str === "showFixedHedged") {
        Object.assign(this.Analytics["userSelections"], {
          showFixedFutures: true,
        });
        Object.assign(this.Analytics["userSelections"], {
          showHedgedFutures: bool,
        });
      }

      Object.assign(this.Analytics["userSelections"], {
        [str]: bool,
      });
      if (str === "showAll" || (str === "showAve" && bool)) {
        const sts = [
          "showLCall",
          "showLFwd",
          "showLPut",
          "showSCall",
          "showSFwd",
          "showSPut",
        ];
        for (const subStr of sts) {
          Object.assign(this.Analytics["userSelections"], {
            [subStr]: bool,
          });
        }
      }
      if (str === "includeRatio") {
        if (!bool) {
          Object.assign(this.Analytics["userSelections"], {
            includeBasis: bool,
          });
        } else if (this.Analytics["userSelections"]["includeBasis"]) {
          Object.assign(this.Analytics["userSelections"], {
            includeFutures: bool,
          });
        }
      } else if (str === "includeFutures") {
        if (!bool) {
          Object.assign(this.Analytics["userSelections"], {
            includeBasis: bool,
          });
        } else if (this.Analytics["userSelections"]["includeBasis"]) {
          Object.assign(this.Analytics["userSelections"], {
            includeRatio: bool,
          });
        }
      } else if (str === "includeBasis") {
        if (
          bool &&
          (this.Analytics["userSelections"]["includeFutures"] ||
            this.Analytics["userSelections"]["includeRatio"])
        ) {
          Object.assign(this.Analytics["userSelections"], {
            includeFutures: bool,
          });
          Object.assign(this.Analytics["userSelections"], {
            includeRatio: bool,
          });
        }
      }

      if (
        str === "includeRatio" ||
        str === "includeFutures" ||
        str === "includeBasis"
      ) {
        if (this.Analytics["userSelections"]["includeFutures"]) {
          if (this.Analytics["userSelections"]["includeRatio"]) {
            if (this.Analytics["userSelections"]["includeBasis"]) {
              this.Analytics["userSelections"]["fldBudget"] = "budgetP";
              this.Analytics["userSelections"]["fldFixed"] = "fixedP";
              this.Analytics["userSelections"]["fldMkt"] = "marketP";
              this.Analytics["userSelections"]["fldNet"] = "netP";
              this.Analytics["userSelections"]["fldFixedPerc"] = "fixedPPerc";
              this.Analytics["userSelections"]["fldMktPerc"] = "marketPPerc";
              this.Analytics["userSelections"]["fldNetPerc"] = "netPPerc";
            } else {
              this.Analytics["userSelections"]["fldBudget"] = "budgetPFutRatio";
              this.Analytics["userSelections"]["fldFixed"] = "fixedPFutRatio";
              this.Analytics["userSelections"]["fldMkt"] = "marketPFutRatio";
              this.Analytics["userSelections"]["fldNet"] = "netPFutRatio";
              this.Analytics["userSelections"]["fldFixedPerc"] =
                "fixedPFutRatioPerc";
              this.Analytics["userSelections"]["fldMktPerc"] =
                "marketPFutRatioPerc";
              this.Analytics["userSelections"]["fldNetPerc"] =
                "netPFutRatioPerc";
            }
          } else {
            this.Analytics["userSelections"]["fldBudget"] = "budgetPFut";
            this.Analytics["userSelections"]["fldFixed"] = "fixedPFut";
            this.Analytics["userSelections"]["fldMkt"] = "marketPFut";
            this.Analytics["userSelections"]["fldNet"] = "netPFut";
            this.Analytics["userSelections"]["fldFixedPerc"] = "fixedPFutPerc";
            this.Analytics["userSelections"]["fldMktPerc"] = "marketPFutPerc";
            this.Analytics["userSelections"]["fldNetPerc"] = "netPFutPerc";
          }
        } else {
          if (this.Analytics["userSelections"]["includeRatio"]) {
            this.Analytics["userSelections"]["fldBudget"] = "budgetPRatio";
            this.Analytics["userSelections"]["fldFixed"] = "fixedPRatio";
            this.Analytics["userSelections"]["fldMkt"] = "marketPRatio";
            this.Analytics["userSelections"]["fldNet"] = "netPRatio";
            this.Analytics["userSelections"]["fldFixedPerc"] =
              "fixedPRatioPerc";
            this.Analytics["userSelections"]["fldMktPerc"] = "marketPRatioPerc";
            this.Analytics["userSelections"]["fldNetPerc"] = "netPRatioPerc";
          } else {
            if (this.Analytics["userSelections"]["includeBasis"]) {
              this.Analytics["userSelections"]["fldBudget"] = "budgetPOther";
              this.Analytics["userSelections"]["fldFixed"] = "fixedPOther";
              this.Analytics["userSelections"]["fldMkt"] = "marketPOther";
              this.Analytics["userSelections"]["fldNet"] = "netPOther";
              this.Analytics["userSelections"]["fldFixedPerc"] =
                "fixedPOtherPerc";
              this.Analytics["userSelections"]["fldMktPerc"] =
                "marketPOtherPerc";
              this.Analytics["userSelections"]["fldNetPerc"] = "netPOtherPerc";
            } else {
              this.Analytics["userSelections"]["fldBudget"] = null;
              this.Analytics["userSelections"]["fldFixed"] = null;
              this.Analytics["userSelections"]["fldMkt"] = null;
              this.Analytics["userSelections"]["fldNet"] = null;
              this.Analytics["userSelections"]["fldFixedPerc"] = null;
              this.Analytics["userSelections"]["fldMktPerc"] = null;
              this.Analytics["userSelections"]["fldNetPerc"] = null;
            }
          }
        }
      }
      Object.assign(this.Analytics["rawData"], {
        render: !this.Analytics["rawData"]["render"],
      });
    },
    onUserShowDetails() {
      let bool = this.Analytics["userSelections"]["showDetails"];
      Object.assign(this.Analytics["userSelections"], { showDetails: !bool });
    },
    onUserZoom(num) {
      let step;
      let xZoom = this.Analytics["userSelections"].xZoom;
      Object.assign(this.Analytics["userSelections"], { year: null });
      if (num === 1) {
        step = Math.max(0, xZoom[0] - 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [step, xZoom[1]],
        });
      } else if (num === 2) {
        step = Math.min(xZoom[1] - 1, xZoom[0] + 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [step, xZoom[1]],
        });
      } else if (num === 3) {
        step = Math.max(xZoom[0], xZoom[1] - 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [xZoom[0], step],
        });
      } else {
        step = Math.min(
          this.Analytics["rawData"]["nestedData"].length,
          xZoom[1] + 1,
        );
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [xZoom[0], step],
        });
      }
      this.zoomAndRender();
    },
    zoomAndRender() {
      Object.assign(this.Analytics["rawData"], {
        zoomedData: this.Analytics.zoomData(
          this.Analytics["rawData"]["nestedData"],
          this.Analytics["userSelections"]["xZoom"],
        ),
      });
      this.Analytics.filterHedges();
      Object.assign(this.Analytics["rawData"], {
        totals: [this.Analytics.zoomedTotals()],
        render: !this.Analytics["rawData"]["render"],
      });
    },
    onUserNormalizeQty() {
      Object.assign(this.Analytics["userSelections"], {
        normalizeQty: !this.Analytics["userSelections"]["normalizeQty"],
      });
      Object.assign(this.Analytics["rawData"], {
        render: !this.Analytics["rawData"]["render"],
      });
    },
    onUserYear(yearNum) {
      let xRange = [
        this.Analytics["rawData"]["years"][yearNum]["initial"],
        this.Analytics["rawData"]["years"][yearNum]["final"],
      ];
      Object.assign(this.Analytics["userSelections"], {
        year: yearNum,
        xZoom: xRange,
      });
      this.zoomAndRender();
    },
    resizeCharts() {
      let rBool = this.Analytics["rawData"]["render"];
      for (let i = 0; i < 1; i++) {
        setTimeout(() => {
          Object.assign(this.Analytics["rawData"], {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }
      this.onUserShow();
    },
    // === to db
    saveAllPreferences() {
      this.analytics_preferences.selected_company = this.selectedCompanies;
      this.analytics_preferences.selected_portfolio = this.selectedPortfolios;
      this.analytics_preferences.selected_currencies = [this.currencyString];
      this.$store.state.user_preferences.all.items.analytics_choices = this.analytics_preferences;
      saveUserPreferences(this);
    },
    // === user interactions
    onLeftSidebarAnalysisScenarios({ getEvent }) {
      this.eventElement = getEvent;
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this.Analytics["userSelections"], {
        selectedAnalysisParent: parent,
      });
      Object.assign(this.Analytics["userSelections"], {
        selectedAnalysis: val,
      });
      setTimeout(() => {
        Object.assign(this.Analytics["userSelections"], {
          visibleLeft: false,
        });
      }, 500);

      this.updateRoute();
      this.syncPreferencesFromAnalytics();
      this.saveUserPrefs();
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this.Analytics["userSelections"], {
        visibleLeft: val,
      });
    },
    onUserSpotChange(val) {
      let _this = this;
      Object.assign(this.Analytics["loading"], {
        topographyCalcs: true,
      });
      this.showLoadingValuating = true;
      let spot = val;
      Object.assign(this.Analytics["rawData"], {
        spot: val,
      });
      Object.assign(this.Analytics["rawData"], {
        prevSpot: val,
      });
      this.Analytics["rawData"]["expo"].forEach(function(d) {
        if (Math.min(+d.hedged_date, +d.date) > +_this.today) {
          if (!("fwd_original" in d)) {
            d.fwd_original = +d.fwd;
          }
          d.fwd = spot;
          d.spot = spot;
        }
      });

      if (this.Analytics["rawData"]["hedges"].length > 0) {
        this.Analytics["rawData"]["hedges"].forEach(function(d) {
          if (Math.min(+d.hedged_date, +d.date) > +_this.today) {
            if (!("fwd_original" in d)) {
              d.fwd_original = +d.fwd;
            }
            d.fwd = spot;
            d.spot = spot;
          }
        });
        this.spot = spot;
        this.isCents = 1;
        this.Analytics.postAnalyticsCurrencyUpdate(
          this,
          this.Analytics["rawData"]["hedges"],
          this.Analytics["rawData"]["expo"],
        );
      } else {
        this.showLoadingValuating = false;
        Object.assign(this.Analytics["loading"], {
          topographyCalcs: false,
        });
        throw Error("No hedge data raw available");
      }
    },
    // = valuation
    getValuationSpots(getInitial = true, getFinal = true) {
      if (getInitial === true) {
        getCurrencySettle(
          this.Analytics,
          "initialSpot",
          "valuationInitialSpot",
          this.Analytics["valuation"].initialDate,
          this.Analytics["userSelections"].selectedAsset[0].pk_i_idcurrency,
          "initialDate",
        );
      }
      if (getFinal === true) {
        getCurrencySettle(
          this.Analytics,
          "finalSpot",
          "valuationFinalSpot",
          this.Analytics["valuation"].finalDate,
          this.Analytics["userSelections"].selectedAsset[0].pk_i_idcurrency,
          "finalDate",
        );
      }
    },
    onUserAccountingValuate() {
      const extraParams = {
        initialPrice: this.Analytics.valuation["initialSpot"],
        endPrice: this.Analytics.valuation["finalSpot"],
      };
      this.Analytics.postPortfolioValuation(extraParams);
    },
    onUserInitialSpotChange(val) {
      Object.assign(this.Analytics["valuation"], {
        initialSpot: val,
      });
    },
    onUserInitialSpotRefresh() {
      this.getValuationSpots(true, false);
    },
    onUserFinalSpotChange(val) {
      Object.assign(this.Analytics["valuation"], {
        finalSpot: val,
      });
    },
    onUserFinalSpotRefresh() {
      this.getValuationSpots(false);
    },
    // ========== animations ==========
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped></style>
